import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

export default function StatisticsDesktopAttendanceBreakdownCard({
    attendanceBreakdownStats,
    isEditMode,
    longPressHandlers,
}) {
    const { containerRef, isReady } = useChartContainerReady();

    return (
        <StatisticsGlassCard className="h-full p-5 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
            <StatisticsDesktopSectionHeader
                iconSrc={STATS_ICONS.people}
                title="출석 구성 분석"
                badge="비율"
            />

            <div ref={containerRef} className="flex-1 min-h-[180px] min-w-0">
                {attendanceBreakdownStats.length > 0 ? (
                    isReady ? (
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={attendanceBreakdownStats} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F3F4F6" />
                                <XAxis
                                    dataKey="date"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fontSize: 11, fontWeight: 600, fill: '#9CA3AF' }}
                                />
                                <YAxis
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fontSize: 10, fill: '#D1D5DB' }}
                                    domain={[0, 100]}
                                    tickFormatter={(v) => `${v}%`}
                                />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                        padding: '10px 14px',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                    }}
                                    formatter={(value, name) => [`${value}%`, name]}
                                />
                                <Legend
                                    wrapperStyle={{ fontSize: '11px', fontWeight: 'bold', paddingTop: '8px' }}
                                    iconType="circle"
                                    iconSize={8}
                                />
                                <Bar dataKey="출석" stackId="a" fill="#10B981" radius={[0, 0, 0, 0]} barSize={20} />
                                <Bar dataKey="지각" stackId="a" fill="#F59E0B" radius={[0, 0, 0, 0]} barSize={20} />
                                <Bar dataKey="결석" stackId="a" fill="#EF4444" radius={[4, 4, 0, 0]} barSize={20} />
                            </BarChart>
                        </ResponsiveContainer>
                    ) : null
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">
                        <div className="text-center">
                            <div className="text-3xl mb-2">📋</div>
                            <p className="text-sm">출석 데이터가 없습니다</p>
                        </div>
                    </div>
                )}
            </div>
        </StatisticsGlassCard>
    );
}
